import React from 'react';

const SearchTags: React.FunctionComponent = () => {
  return <div data-hideable data-widget="tags" className="tags-container"></div>;
};

export default SearchTags;
